import { Box, Form } from "dash-ui";
import { SettingsFieldProps } from "./CmsSettingsContent.types";
import {
  FormFieldLabel,
  HelpText,
  StyledInput,
} from "./CmsSettingsContent.styles";
import { CMS_SETTINGS_LIMITS } from "./CmsSettingsContent.constants";

const SettingsField = ({
  label,
  helpText,
  value,
  fieldName,
  onChange,
  disabled,
  min = CMS_SETTINGS_LIMITS.MIN_DAYS,
  max = CMS_SETTINGS_LIMITS.MAX_DAYS,
}: SettingsFieldProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;

    // Allow empty string for editing (user clearing the field)
    if (inputValue === "") {
      onChange(fieldName, "");
      return;
    }

    const numValue = parseInt(inputValue);
    if (!isNaN(numValue)) {
      // Allow any number while typing, the HTML validation will handle bounds on submit
      onChange(fieldName, numValue);
    }
  };

  return (
    <Form.Group>
      <FormFieldLabel>{label}</FormFieldLabel>
      <HelpText>{helpText}</HelpText>
      <Box mt={2}>
        <StyledInput
          type="number"
          min={min}
          max={max}
          value={value}
          onChange={handleChange}
          disabled={disabled}
          required
        />
      </Box>
    </Form.Group>
  );
};

export default SettingsField;
